import axios from 'axios';

export default {
  all(params = {}) {
    return axios.get('/articles', {params});
  },
  active(params = {}) {
    return axios.get('/articles/get-active', {params});
  },
  detail(id: string | number, params = {}) {
    return axios.get(`/articles/${id}`, {params});
  },
};
